import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from '@phosphor-icons/react';

/**
 * Bottom sheet con TODAS las categorías de la sección, en grid (estilo
 * "¿Qué se te antoja?"). Tocar una categoría la selecciona y cierra el sheet.
 */
export default function CategoriesModal({ isOpen, onClose, categories = [], onSelect }) {
  // Bloquea el scroll del fondo mientras está abierto.
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [isOpen]);

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/50 z-[60]"
          />
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 30, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 z-[60] bg-white rounded-t-3xl max-h-[85vh] flex flex-col"
          >
            <div className="flex items-center justify-between px-5 pt-5 pb-3">
              <h2 className="text-[22px] font-extrabold font-display tracking-tight text-gray-900">
                ¿Qué se te antoja?
              </h2>
              <button
                onClick={onClose}
                aria-label="Cerrar"
                className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 active:scale-90 transition-transform flex-shrink-0"
              >
                <X size={18} weight="bold" />
              </button>
            </div>
            <div className="h-px bg-gray-100 mx-5" />

            <div
              className="overflow-y-auto px-4 py-5"
              style={{ paddingBottom: 'max(env(safe-area-inset-bottom), 1.25rem)' }}
            >
              <div className="grid grid-cols-4 gap-x-2 gap-y-6">
                {categories.map((cat) => (
                  <button
                    key={cat._id}
                    type="button"
                    onClick={() => { onSelect?.(cat._id); onClose(); }}
                    className="flex flex-col items-center gap-1.5 active:scale-95 transition-transform"
                  >
                    <div className="w-16 h-16 flex items-center justify-center">
                      {cat.image ? (
                        <img
                          src={cat.image}
                          alt={cat.name}
                          className="w-full h-full object-contain"
                          loading="lazy"
                        />
                      ) : (
                        <span className="text-4xl">{cat.icon || '🍽️'}</span>
                      )}
                    </div>
                    <span className="text-[14.5px] font-semibold tracking-tight text-gray-600 text-center leading-tight truncate w-full">
                      {cat.name}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body
  );
}
